import { debug, george, observer, pr, React, theme, ui } from "aaa";
import { ContactsStore } from "stores/ContactsStore";
import trackingStore from "stores/TrackingStore";
import { NewEmail } from "./NewEmail";

const ADD_NEW_KEY = "addNew";
const EMPTY_KEY = "noEmail";

const EMPTY_OPTION = {
    value: EMPTY_KEY,
    label: ""
};

type IEmailOption = { value: string; label: string };

export const ChooseEmailDropdown = observer(({
    contactsStore,
    onEmailChanged,
    selectedEmailId,
}: {
    contactsStore: ContactsStore,
    onEmailChanged?: (emailId: string) => void,
    selectedEmailId?: string,
}) => {
    const [showNewEmail, setShowNewEmail] = React.useState(false);

    const ADD_NEW_OPTION = {
        value: ADD_NEW_KEY,
        label: ui.__("email.addNew")
    };

    let currentValue;
    let items: IEmailOption[] = [];

    if (contactsStore.emailAddresses && contactsStore.emailAddresses.length > 0) {
        items = contactsStore.emailAddresses.map(contact => { return { value: contact.id, label: contact.email!.email }; });
    } else {
        items.push(EMPTY_OPTION);

        currentValue = EMPTY_KEY;
    }

    items.push(ADD_NEW_OPTION);

    if (selectedEmailId) {
        currentValue = selectedEmailId;
    } else if (contactsStore.selectedEmailAddressId) {
        currentValue = contactsStore.selectedEmailAddressId;
    } else if (contactsStore.emailAddresses && contactsStore.emailAddresses.length > 0) {
        currentValue = contactsStore.emailAddresses[0].id;
    }

    debug.log("### current email", currentValue);

    const handleChangeEmail = async (event: any, index: number, value: string) => {
        if (value === ADD_NEW_KEY) {
            setShowNewEmail(true);
            ui.isPopupVisible = true;
        } else if (onEmailChanged) {
            onEmailChanged(value);
            await trackingStore.trackEvent({ eventName: "emailChosen" });
        } else {
            contactsStore.selectedEmailAddressId = value;
            await trackingStore.trackEvent({ eventName: "emailChosen" });
        }
    };

    return (
        <>
            <pr.A11yPopupHider>
                <george.DropDown
                    isLoading={contactsStore.isLoading}
                    value={currentValue}
                    onChange={handleChangeEmail}
                    aria-label={ui.__("a11y.chooseEmail")}
                    items={items}
                />
            </pr.A11yPopupHider>
            <NewEmail
                show={showNewEmail}
                contactsStore={contactsStore}
                onClose={
                    () => {
                        setShowNewEmail(false);
                        ui.isPopupVisible = false;
                    }
                }
            />
        </>
    );
});

export const ChooseEmailEmbedded = observer(({
    contactsStore,
    description,
    onEmailChanged,
    selectedEmailId,
}: {
    contactsStore: ContactsStore,
    description?: string,
    onEmailChanged?: (emailId: string) => void,
    selectedEmailId?: string,
}) => {
    return (
        <div>
            <pr.A11yPopupHider>
                <george.SectionTitle>{ui.__("loan.summary.yourEmail")}</george.SectionTitle>
                {description &&
                    <pr.P_14_CONTENT style={{ marginBottom: theme.MARGIN }}>
                        {description}
                    </pr.P_14_CONTENT>
                }
            </pr.A11yPopupHider>
            <ChooseEmailDropdown
                contactsStore={contactsStore}
                onEmailChanged={onEmailChanged}
                selectedEmailId={selectedEmailId}
            />
        </div>
    );
});

export const ChooseEmail = observer(({
    contactsStore,
    description,
    onEmailChanged,
    selectedEmailId,
}: {
    contactsStore: ContactsStore,
    description?: string,
    onEmailChanged?: (emailId: string) => void,
    selectedEmailId?: string,
}) => {
    return (
        <div>
            <george.Card>
                <pr.A11yPopupHider>
                    <george.CardSectionTitle title={ui.__("loan.summary.yourEmail")} />
                </pr.A11yPopupHider>
                <george.CardSectionContent>
                    <pr.A11yPopupHider>
                        {description &&
                            <pr.P_14_CONTENT style={{ marginBottom: theme.MARGIN }}>
                                {description}
                            </pr.P_14_CONTENT>
                        }
                    </pr.A11yPopupHider>
                    <ChooseEmailDropdown
                        contactsStore={contactsStore}
                        onEmailChanged={onEmailChanged}
                        selectedEmailId={selectedEmailId}
                    />
                </george.CardSectionContent >
            </george.Card>
        </div>
    );
});

export const ChooseEmailResponsive = observer(({
    contactsStore,
    description,
    onEmailChanged,
    selectedEmailId,
    icon,
}: {
    contactsStore: ContactsStore,
    description?: string,
    onEmailChanged?: (emailId: string) => void,
    selectedEmailId?: string,
    icon?: React.ReactNode

}) => {
    return (
        <div>
            <pr.A11yPopupHider>
                {description &&
                    <>
                        <george.SectionTitle style={{ marginTop: 0 }}>
                            {ui.__("loan.summary.yourEmail")}
                        </george.SectionTitle>
                        <pr.P_14_CONTENT style={{ marginBottom: theme.MARGIN }}>
                            {description}
                        </pr.P_14_CONTENT>
                    </>
                }
            </pr.A11yPopupHider>
            <george.ResponsiveFormElement label={
                icon ?
                    <pr.HFlex style={{ alignItems: "center", gap: 8 }}>
                        {icon}
                        {ui.__("common.email")}
                    </pr.HFlex>
                    : ui.__("common.email")}
            >
                <ChooseEmailDropdown
                    contactsStore={contactsStore}
                    onEmailChanged={onEmailChanged}
                    selectedEmailId={selectedEmailId}
                />
            </george.ResponsiveFormElement>
        </div>
    );
});



// WEBPACK FOOTER //
// ./src/components/common/ChooseEmail.tsx